var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.375,
    height: 20.015,
    viewBox: "0 0 16.375 20.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-3 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224416",
    "data-name": "Path 224416",
    d: "M17.646,7a.91.91,0,0,0-.91.91V18.09a1.747,1.747,0,0,1-1.829,1.646H7.648A1.747,1.747,0,0,1,5.819,18.09V7.91A.91.91,0,0,0,4,7.91V18.09a3.564,3.564,0,0,0,3.648,3.465h7.26a3.564,3.564,0,0,0,3.648-3.465V7.91A.91.91,0,0,0,17.646,7Z",
    transform: "translate(-0.09 -0.542)",
    fill: "#4c5a6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224417",
    "data-name": "Path 224417",
    d: "M18.465,3.729H14.826V1.91a.91.91,0,0,0-.91-.91H8.458a.91.91,0,0,0-.91.91V3.729H3.91a.91.91,0,1,0,0,1.819H18.465a.91.91,0,1,0,0-1.819Zm-9.1,0v-.91h3.639v.91Z",
    fill: "#4c5a6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224418",
    "data-name": "Path 224418",
    d: "M10.819,16.278V9.91A.91.91,0,0,0,9,9.91v6.368a.91.91,0,1,0,1.819,0Z",
    transform: "translate(-0.542 -0.722)",
    fill: "#4c5a6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224419",
    "data-name": "Path 224419",
    d: "M14.819,16.278V9.91A.91.91,0,0,0,13,9.91v6.368a.91.91,0,1,0,1.819,0Z",
    transform: "translate(-0.903 -0.722)",
    fill: "#4c5a6a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.835b4604c92440a60e33874a998486d4.svg";
export { ForwardRef as ReactComponent };